'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n'], ['\n  ', '\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Disabled = _styledComponents2.default.div(_templateObject, function (props) {
  return props.disabled && 'opacity: 0.4;\n     position: relative;\n     cursor: not-allowed;\n\n     &:before {\n       content: \'\';\n       width: 100%;\n       height: 100%;\n       display: block;\n       position: absolute;\n     }';
});

Disabled.displayName = 'Disabled';

exports.default = Disabled;
//# sourceMappingURL=Disabled.js.map


//////////////////
// WEBPACK FOOTER
// ../card-drawer/lib/Disabled.js
// module id = 151
// module chunks = 0